<template>
  <div class="to-guild-leader-box">
    <top-header :text="$t('guild_salary_to_reseller')" :color="'#000'"></top-header>
    <div class="content-box">
      <div class="inputUid">
        <input type="number" 
        v-model="resellerId" 
        :placeholder="$t('guild_please_enter_reseller_uid')" 
        @keyup.enter="searchReseller"
        @input="handleInput"
        @blur="searchReseller" />
        <span class="search-btn" v-if="resellerId.length>0" @click="searchReseller"></span>
      </div>
      <div v-if="resellerList.length>0" class="user-info-box-parent">
        <div class="user-info-box" v-for="item in resellerList" :key="item.userId">
          <div class="avatar-box">
            <img :src="item.headIcon" alt="">
          </div>
          <div class="user-name-tips">
            <p>{{ item.nickname }}</p>
            <p class="reseller-yes" v-if="item.resellerFlag == 1">{{ $t('guild_amount_refunded') }}</p>
            <p class="reseller-not" v-else>{{ $t('guild_status_pending') }}</p>
          </div>
          <div class="selectBtn" :class="isSelected(item) ? 'selectBtn-act' : '' " @click="changeResellerId(item)"></div>
        </div>
      </div>
      
      <div class="can-withdrawal-box">{{ $t('guild_status_completed') }}<span>{{ toEnglishNumbers(currentCoin.toLocaleString('en-US')) }}</span></div>
      <!-- 交换区域 -->
      <div class="swap-container">
        <!-- 上方输入组 -->
        <div
          class="input-group swap-item swap-item-top"
          :class="{ 'is-swapping': isSwapping }"
        > 
          <div class="label">{{ isTopFrom ? $t('guild_status_rejected') : $t('guild_show_last_3_months') }}</div>
          <div class="value-row">
            <template v-if="isTopFrom">
              <img src="../../assets/withdrawal/coin-big.png" alt="coin" class="icon" />
              <input
                v-model="toAmount"
                @input="changeAmount"
                @focus="handleFocus"
                @blur="handleBlur"
                type="text"
                inputmode="decimal"
                :class="['amount-input', { 'amount-input-gray': toAmount == '0' || toAmount === 0 }]"
              />
            </template>
            <template v-else>
               <img src="../../assets/withdrawal/zuan.png" alt="coin" class="icon" />
              <input
                v-model="fromAmount"
                @input="changeAmount"
                type="text"
                inputmode="decimal"
                placeholder="0"
                :class="['amount-input', { 'amount-input-gray': fromAmount == '0' || fromAmount === 0 }]"
              />
            </template>
           
          </div>
        </div>
        <!-- 交换按钮 -->
        <!-- <div class="swap-btn" :class="{
          'swap-btn-act': amount > 0
        }" @click="swapValues">
        </div> -->
        <!-- 下方输入组 -->
        <!-- <div
          class="input-group swap-item swap-item-bottom"
          :class="{ 'is-swapping': isSwapping }"
        >
          <div class="label">{{ isTopFrom ? $t('guild_show_last_3_months') : $t('guild_status_rejected') }}</div>
          <div class="value-row">
            <img v-if="isTopFrom" src="../../assets/withdrawal/zuan.png" alt="coin" class="icon" />
            <img v-else src="../../assets/withdrawal/coin-big.png" alt="coin" class="icon" />
            <input
              disabled
              :value="toEnglishNumbers(amount)"
              type="text"
              placeholder="0"
              :class="['amount-input', { 'amount-input-gray': amount == '0' || amount === 0 }]"
            />
          </div>
        </div> -->
      </div>

      <div class="tips-box">
        <header>{{ $t('guild_read_before_withdraw') }}</header>
        <ul class="withrawal-tips">
          <li>
            {{ $t('guild_read_before_operation') }}
          </li>
          <li>{{ $t('guild_transfer_note_1') }}</li>
          <li>{{ $t('guild_page_minimum',{n:this.applyMinNum}) }}</li>
        </ul>
      </div>
      <div class="submit-btn" @click="confirmBtn">{{ $t('guild_transfer_note_2') }}</div>
    </div>

    <!-- 自定义弹窗 -->
    <div v-if="showPop" class="custom-popup-mask" @click="closePopup">
      <div class="custom-popup-content" @click.stop>
        <div class="safety-icon"></div>
        <p class="pop-title">{{ $t('guild_confirm_transfer') }}</p>
        <p class="pop-tips" v-if="isTopFrom" v-html="$t('guild_confirm_submit_transfer', { n: `<span>${toEnglishNumbers(toAmount)}</span>` })">
        </p>
        <p class="pop-tips" v-else v-html="$t('guild_confirm_submit_transfer', { n: `<span>${toEnglishNumbers(amount)}</span>`, m: `<span>${toEnglishNumbers(fromAmount)}</span>` })">
        </p>
        <div class="pop-tips-content">
            <span class="pop-tips-content-icon"></span>
            {{$t('guild_deduct_pcoin_receive_diamond')}}
        </div>
        <div class="popup-footer">
          <button class="btn-confirm" @click="confirm">{{ $t('guild_appeal_to_platform') }}</button>
          <button class="btn-cancel" @click="closePopup">{{ $t('guild_withdraw_note_4') }}</button>
        </div>
      </div>
    </div>
    <div class="loading-box" v-if="loading">
      <van-loading type="spinner" vertical />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Loading,Toast,Dialog } from 'vant';
import topHeader from '@/components/withdrawal/top-header.vue';

export default {
  name: 'toguildleader',
  components: {
    topHeader,
    VanLoading: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      loading: false,
      resellerId: '',
      selectedUserId: null, // 记录选中的用户ID
      toResellerId:'',//传给后台
      fromAmount: '',
      toAmount: 0,
      amount:0,
      isTopFrom: true,
      isSwapping: false,
      showPop:false,
      guildId:100997,//公会ID
      guildUid:793228,//公会长uid
      currentCoin:0,//可提现
      resellerList:[],
      convertPer:0, //转换比例
      applyMinNum:0,//最小值
    };
  },
  created() {
    this.getUserInfo();
    this.initResellerInfo();
    this.guildId = this.$route.query.guildId;
    this.guildUid = this.$route.query.guildUid;
    this.applyMinNum = this.$route.query.minCoin || 0;
  },
  computed:{
  },
  methods: {
    // 处理焦点事件
    handleFocus() {
      if (this.toAmount == '0') {
        this.toAmount = '';
      }
    },
    handleBlur() {
      if (this.toAmount === '') {
        this.toAmount = '0';
      }
    },
    // 转换阿拉伯数字为英文数字
    toEnglishNumbers(str) {
      return str.toString().replace(/[٠-٩]/g, (d) => {
        return '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)];
      });
    },
    // 处理输入变化
    handleInput() {
      // 只保留数字
      this.resellerId = this.resellerId.replace(/[^\d]/g, '');
      if (!this.resellerId) {
        this.resellerList = [];
      }
    },
    // 确认转账校验
    confirmBtn(){
      if(this.resellerId == ''){
        Toast(this.$t('guild_please_enter_reseller_uid'));
        return;
      }
      if(this.resellerList.length == 0){
        Toast(this.$t('guild_please_search_reseller_first'));
        return;
      }
      // 校验 resellerId 是否在搜索结果中
      const isValidReseller = this.resellerList.some(item => item.userId == this.resellerId || item.prettyNumber == this.resellerId);
      if(!isValidReseller){
        Toast(this.$t('guild_please_search_reseller_first'));
        return;
      }
      if(this.fromAmount == 0 && this.toAmount == 0){
        Toast(this.$t('guild_please_enter_amount'));
        return;
      }
      if(this.toAmount > this.currentCoin){
        Toast(this.$t('guild_insufficient_balance'));
        return;
      }

        if(Number(this.toAmount) < Number(this.applyMinNum)){
            return Toast(this.$t('guild_tips_1') + this.applyMinNum);
        }
      this.showPop = true;
    },
    // 判断是否选中
    isSelected(item) {
      return this.selectedUserId === item.userId;
    },
    // 修改resellerid
    changeResellerId(item){
      // 如果当前项已经被选中，则取消选中
      if(this.selectedUserId === item.userId){
        this.selectedUserId = null;
        this.resellerId = '';
        this.toResellerId = '';
      } else {
        // 选中新的项目
        this.selectedUserId = item.userId;
        this.resellerId = (item.prettyNumber || item.userId).toString();
        this.toResellerId = item.userId;
      }
    },
    // 搜索reseller
    searchReseller(){
      if(!this.resellerId){return}
      this.loading = true;
      let that = this;
      axios
        .get(this.$serviceIp +'api/code/family/searchForRetrievePwd?uid=' + that.resellerId,{
            headers: {
                'deviceId': this.deviceId,
                'version': '3.0',
                'lang': this.lang,
              }
        })
        .then(({data}) => {
          if (data.code == 200) {
            if(data.data.checkResult == 1){
              Toast(this.$t('guild_user_not'));
              this.resellerList = [];
            }else{
              this.resellerList = data.data.personList;
              // 搜索完成后检查是否有匹配项，优先匹配靓号
              let matchedItem = this.resellerList.find(item => 
                item.prettyNumber && item.prettyNumber == this.resellerId
              );
              if(!matchedItem){
                matchedItem = this.resellerList.find(item => 
                  item.userId == this.resellerId
                );
              }
              if(matchedItem){
                this.selectedUserId = matchedItem.userId;
                this.toResellerId = matchedItem.userId;
              }
            }
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{}).finally(()=>{
          this.loading = false;
        });
    },   
    // 初始化信息
    initResellerInfo(){
      this.loading = true;
      axios
        .get(this.$serviceIp +`api/trade/guild/withdraw/reseller/init?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId,
                'version': '3.0',
                'lang': this.lang,
              }
        })
        .then(({data}) => {
          if (data.code == 200) {
            this.convertPer = data.data.convertPer/10000;
            this.currentCoin = data.data.currentCoin;
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{}).finally(()=>{
          this.loading = false;
        });
    },
    closePopup() {
      this.showPop = false;
    },
    confirm() {
      let that = this;
      this.loading = true;
      this.closePopup();
      let data = {
        guildId: that.guildId, //公会ID必填用于判断开关
        resellerId: that.toResellerId, //转给的resellerid
        coinNum: 0,  //转出P币数（必填）
        diamondNum:0 //转入钻石数（必填）
      }
      // 真  p币转钻石 假  钻石转P币
      if(this.isTopFrom){
        data.coinNum = that.toAmount;
        data.diamondNum = that.amount;
      }else{
        data.coinNum = that.amount;
        data.diamondNum = that.fromAmount;
      }
       axios({
        url: that.$serviceIp + `api/trade/guild/withdraw/transfertoReseller/apply`,
        method: "post",
          headers: {
            'version': '3.0',
            'deviceId': that.deviceId,
            'lang': that.lang,
          },
        data,
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
          this.closePopup();
          Dialog.alert({
            message: this.$t('guild_reseller_tips'),
            className: 'guild-reseller-tips',
            confirmButtonText: this.$t('guild_appeal_to_platform') || '确定'
          }).then(() => {
            // on close
            this.$router.go(-1);
          });
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
      }).catch(()=>{}).finally(()=>{
        this.loading = false;
      });
    },
    changeAmount(){
      // 限制只能输入数字，去除0开头
      this.toAmount = this.toAmount.toString().replace(/[^\d]/g, '').replace(/^0+/, '') || '';
      this.fromAmount = this.fromAmount.toString().replace(/[^\d]/g, '').replace(/^0+/, '') || '';
      
      if(this.isTopFrom){
        let result = Math.floor(this.toAmount / this.convertPer);
        this.amount = this.toEnglishNumbers(result);
      }else{
        let result = Math.ceil(this.fromAmount * this.convertPer);
        this.amount = this.toEnglishNumbers(result);
      }
    },
    swapValues() {
      if (this.isSwapping) return; // 防止快速连点导致动画错乱
      this.isSwapping = true;
      this.isTopFrom = !this.isTopFrom;
      if(this.isTopFrom){
        this.toAmount = this.amount;
      }else{
        this.fromAmount = this.amount;
      }
      this.changeAmount()
      // 动画时长与 CSS 一致（300ms）
      setTimeout(() => {
        this.isSwapping = false;
      }, 300);
    },

    getUserInfo() {
      var ids = navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
      );
      if (ids) {
        ids = ids[0];
      } else {
        ids = "Unknown Device";
      }
      let data = JSON.parse(localStorage.getItem("data"));
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || ids;
      let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr";
      } else if (langs == "id") {
        this.$i18n.locale = "id";
      } else if (langs == "ms") {
        this.$i18n.locale = "ms";
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("guild_salary_to_reseller");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    }
  }
};
</script>

<style scoped>
body {
  background-color: #f5f6f8;
  font-family: 'Mada';
}
html[lang="ar"] .to-guild-leader-box{
  direction: rtl;
}
html[lang="ar"] .withrawal-tips li{
    padding-right: 1em;
    padding-left: 0;
}
html[lang="ar"] .tips-box header::before{
    margin-left: 16px;
    margin-right: 0;
}
html[lang="ar"] .selectBtn{
  right: auto;
  left: 8px;
}
html[lang="ar"] .user-name-tips{
  padding-right: 16px;
}
html[lang="ar"] .safety-icon{
  left: 0;
  right: auto;
  transform: scaleX(-1);
}
html[lang="ar"] .pop-tips-content-icon{
  right: 24px;
  left: auto;
}
html[lang="ar"] .pop-tips-content{
  padding: 16px 72px 16px 24px;
}
html[lang="ar"] .swap-btn{
  left: 60px;
  right: auto;
}
html[lang="ar"] .search-btn{
  right: auto;
  left: 28px;
}
.content-box {
  margin-top: 32px;
  padding: 0 48px;
  box-sizing: border-box;
  width: 100vw;
  font-family: 'Mada';
}

.tips-box{
    width: 544px;
    margin: 0 auto;
    margin-top: 48px;
    padding: 16px 24px;
    border-radius: 24px;
    box-sizing: border-box;
    background: linear-gradient(to bottom, rgba(255, 147, 147, 0.6),rgba(255, 147, 147, 0));
}
.tips-box header{
    font-size: 24px;
    color: #FF4365;
    font-weight: 500;
    display: flex;
    margin-bottom: 20px;
}
.tips-box header::before{
    content:'';
    width: 32px;
    line-height: 32px;
    background: url("../../assets/withdrawal/elert.png") no-repeat;
    background-size: 100%;
    margin-right: 16px;
}
.withrawal-tips li{
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    text-indent: -1em;
    padding-left: 1em;
    color: #262427;
}
.withrawal-tips li span{
    font-weight: 600;
}
.appeal-btn{
    color: #4682E9;
}
.submit-btn{
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 422px;
    height: 88px;
    text-align: center;
    border-radius: 44px;
    font-size: 28px;
    line-height: 88px;
    color: #fff;
    background-color: #4D70FF;
}
.inputUid{
  width: 100%;
  height: 88px;
  border: 1px solid #dbdbdb;
  border-radius: 24px;
  position: relative;
}
.inputUid input{
  width: 100%;
  height: 88px;
  background-color: transparent;
  border: none;
  vertical-align: top;
  font-size: 24px;
  line-height: 88px;
  text-align: center;
  font-weight: 500;
  color: #262427;
}
.search-btn{
  position: absolute;
  top: 28px;
  right: 28px;
  width: 32px;
  height: 32px;
  background: url("../../assets/withdrawal/search-btn.png") no-repeat;
  background-size: 100% 100%;
}
.user-info-box-parent{
  border-bottom: 1px solid #EEEEEE;
  padding-bottom: 24px;
}
.user-info-box{
  margin-top: 16px;
  display: flex;
  padding: 0 8px;
  position: relative;
}
.avatar-box img{
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 40px;
}
.user-name-tips{
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.user-name-tips p{
  font-size: 24px;
  font-weight: 600;
  color: #262427;
}
.user-name-tips .reseller-yes{
  font-weight: 500;
  color: #28C256;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.reseller-yes::before{
  content: "";
  width: 28px;
  height: 28px;
  background: url("../../assets/withdrawal/reseller-yes.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 8px;
}
.user-name-tips .reseller-not{
  font-weight: 500;
  color: #FF4343;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.reseller-not::before{
  content: "";
  width: 28px;
  height: 28px;
  background: url("../../assets/withdrawal/reseller-not.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 8px;
}

/* ========== 交换区域核心样式 ========== */
.swap-container {
  width: 544px;
  /* height: 292px; */
  position: relative;
}

.input-group.swap-item {
  width: 100%;
  height: 148px;
  background-color:#EBEBEB;
  border-radius: 24px;
  padding: 24px;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  /* 确保动画层在按钮之上 */
  position: relative;
  z-index: 1;
  box-sizing: border-box;
}
.swap-item-top{
  margin-bottom: 8px;
  border-radius: 24px 24px 0 0;
}
.swap-item-bottom{
  border-radius: 0 0 24px 24px;
}

/* 动画中：第一个（上）向下移动，第三个（下）向上移动 */
.swap-item.is-swapping:nth-child(1) {
  transform: translateY(72px); /* ≈ 一个模块高度 + 16px gap */
}

.swap-item.is-swapping:nth-child(3) {
  transform: translateY(-72px);
}

.swap-btn {
  width: 48px;
  height: 48px;
  background: url("../../assets/withdrawal/swap-btn.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 60px;
  top: 50%;
  transform: translateY(-40%);
  z-index: 2;
}
.swap-btn-act{
  background: url("../../assets/withdrawal/swap-btn-act.png") no-repeat;
  background-size: 100% 100%;

}

.label {
  font-size: 24px;
  color: #89848D;
  margin-bottom: 20px;
}

.value-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  width: 40px;
  height: 40px;
}
.swap-item-bottom .icon{
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.amount-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 36px;
  width: 100%;
  font-weight: 700;
  color: #262427;
  /* direction: ltr !important;
  text-align: left; */
}
.amount-input-gray {
  color: #999999 !important;
}

.can-withdrawal-box{
  font-size: 28px;
  font-weight: 400;
  color: #262427;
  text-align: center;
  padding: 26px 0;
}
.can-withdrawal-box span{
  font-weight: 700;
}
.can-withdrawal-box span::before{
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  background: url("../../assets/withdrawal/coin.png") no-repeat;
  background-size: 100% 100%;
  vertical-align: middle;
  margin: 4px;
}

/* 遮罩层 */
.custom-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end; /* 从底部对齐 */
  align-items: flex-end;
  z-index: 999;
  animation: fadeIn 0.3s ease;
}

/* 弹窗内容 */
.custom-popup-content {
  width: 100%;
  /* height: 656px; */
  box-sizing: border-box;
  max-width: 100vw;
  background: linear-gradient(to bottom, #ECEBFF,#fff);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 48px;
  box-sizing: border-box;
  transform: translateY(100%);
  animation: slideIn 0.3s ease forwards;
  position: relative;
}

/* 动画：遮罩淡入 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 动画：内容从底部滑入 */
@keyframes slideIn {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* 关闭时的反向动画（可选，这里用 v-if 直接移除，所以不需要 out 动画） */
.popup-footer{
    text-align: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
}
.btn-cancel,
.btn-confirm {
  width: 422px;
  height: 88px;
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  border-radius: 44px;
    border: none;
}

.btn-cancel {
  background: #DBDBDB;
  color: #262427;
  margin-top: 24px;
}

.btn-confirm {
  background: #4D70FF;
  color: white;
}
.safety-icon{
    width: 266px;
    height: 266px;
    position: absolute;
    right: 0;
    top: -133px;
    background: url("../../assets/withdrawal/safety-icon.png") no-repeat;
    background-size: 100% 100%;
}
.pop-title{
    font-size: 28px;
    font-weight: 500;
    color: #1f1315;
}
.pop-tips{
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    color: #262427;
    margin-top: 24px;
}
.pop-tips span::before{
    display: inline-block;
    content: "";
    width: 30px;
    height: 30px;
    margin: 0 2px;
    background: url("../../assets/withdrawal/coin-big.png") no-repeat;
    background-size: 100% 100%;
    vertical-align: top;
}
.pop-tips span:nth-of-type(2):before{
    background: url("../../assets/withdrawal/zuan.png") no-repeat;
    background-size: 100% 100%;
}
.pop-tips >>> span::before,
.pop-tips /deep/ span::before,
.pop-tips ::v-deep span::before {
    display: inline-block;
    content: "";
    width: 30px;
    height: 30px;
    margin: 0 2px;
    background: url("../../assets/withdrawal/coin-big.png") no-repeat;
    background-size: 100% 100%;
    vertical-align: top;
}
.pop-tips >>> span:nth-of-type(2):before,
.pop-tips /deep/ span:nth-of-type(2):before,
.pop-tips ::v-deep span:nth-of-type(2):before {
    background: url("../../assets/withdrawal/zuan.png") no-repeat;
    background-size: 100% 100%;
}
.pop-tips-content{
    width: 544px;
    padding: 16px 24px 16px 72px;
    margin: 0 auto;
    box-sizing: border-box;
    font-size: 24px;
    line-height: 30px;
    border-radius: 24px;
    background: linear-gradient(to bottom, rgba(147, 183, 255, 0.5),rgba(147, 255, 212, 0));
    margin-top: 24px;
    position: relative;
    margin-bottom: 42px;
}
.pop-tips-content-icon{
    position: absolute;
    top: 16px;
    left: 24px;
    width: 32px;
    height: 32px;
    background: url("../../assets/withdrawal/ok.png") no-repeat;
    background-size: 100% 100%;
}

.loading-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.selectBtn{
  width: 32px;
  height: 32px;
  background: url("../../assets/withdrawal/select-bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
}
.selectBtn-act{
  background: url("../../assets/withdrawal/ok.png") no-repeat;
  background-size: 100% 100%;
}
</style>

<style>
/* Dialog 全局样式 - Layla Design System */
.guild-reseller-tips {
  border-radius: 24px !important;
}
.guild-reseller-tips .van-dialog__content {
  padding-top: 120px !important;
  position: relative !important;
}
.guild-reseller-tips .van-dialog__content::before {
  content: '' !important;
  position: absolute !important;
  top: 40px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 64px !important;
  height: 64px !important;
  background: url("../../assets/withdrawal/ok.png") no-repeat center !important;
  background-size: contain !important;
}
.guild-reseller-tips .van-dialog__footer {
  padding: 24px !important;
}
.guild-reseller-tips .van-dialog__message {
  font-size: 24px !important;
  font-family: "Mada" !important;
  color: #333333 !important;
  line-height: 1.6 !important;
  padding: 16px 24px !important;
}
.guild-reseller-tips .van-button {
  border: none !important;
}
.guild-reseller-tips .van-button__content {
  width: 100% !important;
  max-width: 420px !important;
  height: 88px !important;
  border-radius: 44px !important;
  background: linear-gradient(135deg, #4B7BFF 0%, #3D6AE8 100%) !important;
  margin: 0 auto !important;
}
.guild-reseller-tips .van-button__text {
  color: #FFFFFF !important;
  font-size: 26px !important;
  line-height: 88px;
  font-weight: 500 !important;
}
.guild-reseller-tips .van-dialog__content--isolated{
  min-height: auto;
}
.van-hairline--top::after{
  display: none;
}
</style>